import { render, staticRenderFns } from "./ModalBody.vue?vue&type=template&id=c35b1502&scoped=true&"
import script from "./ModalBody.vue?vue&type=script&lang=js&"
export * from "./ModalBody.vue?vue&type=script&lang=js&"
import style0 from "./ModalBody.vue?vue&type=style&index=0&id=c35b1502&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c35b1502",
  null
  
)

export default component.exports